import { createFileRoute, redirect } from '@tanstack/react-router';
import { UserRole } from '@ata-digital/client-tax-system-api-client';
import { DeletedAuditBindersPage } from '@/features/preparer/audit-binders/DeletedAuditBindersPage';
import { deletedAuditBindersQueryOptions } from '@/lib/query/options';
import { QueryErrorBoundary } from '@/components/query/QueryErrorBoundary';
import type { AuthState } from '@/hooks/auth/useAuth';

export const Route = createFileRoute('/preparer/audit-binders/deleted')({
  beforeLoad: ({ context }) => {
    // A fresh page load has no cached auth yet, so it passes through to PreparerAuthGuard
    const authState = (
      context as { queryClient: { getQueryData: (key: string[]) => unknown } }
    ).queryClient.getQueryData(['auth', 'session']) as AuthState | undefined;
    if (authState?.isAuthenticated && authState?.user?.role !== UserRole.Admin) {
      throw redirect({ to: '/preparer/audit-binders' });
    }
  },
  loader: async ({ context: { queryClient } }) => {
    const authState = queryClient.getQueryData(['auth', 'session']) as AuthState | undefined;
    if (authState?.token && authState.user?.role === UserRole.Admin) {
      queryClient.prefetchQuery(deletedAuditBindersQueryOptions.list(authState.token)).catch(() => {});
    }
  },
  errorComponent: QueryErrorBoundary,
  component: DeletedAuditBindersPage,
});
